import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL + '/Remise';

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export const remiseService = {
  getRemises: async (pageNumber = 1, size = 10, searchTerms = '') => {
    const response = await api.get('/Pagination', {
      params: { PageNumber: pageNumber, Size: size, searchTerms },
    });
    const data = response.data;
    return {
      data: data.list || [],
      totalItems: data.total || 0,
      totalPages: data.maxPage || 0,
      currentPage: data.page || 1,
      pageSize: data.pageSize || size,
    };
  },

  getAllActive: async () => {
    const response = await api.get('/Active');
    return response.data;
  },

  createRemise: async (remiseData) => {
    const payload = {
      id: 0,
      pourcentage: parseFloat(remiseData.pourcentage),
      probabilite: parseFloat(remiseData.probabilite),
      label: remiseData.label,
      color: remiseData.color || null,
      textColor: remiseData.textColor || null,
      isActive: remiseData.isActive !== undefined ? remiseData.isActive : true,
    };
    const response = await api.post('', payload);
    return response.data;
  },

  updateRemise: async (id, remiseData) => {
    const payload = {
      id,
      pourcentage: parseFloat(remiseData.pourcentage),
      probabilite: parseFloat(remiseData.probabilite),
      label: remiseData.label,
      color: remiseData.color || null,
      textColor: remiseData.textColor || null,
      isActive: remiseData.isActive !== undefined ? remiseData.isActive : true,
    };
    const response = await api.put('', payload);
    return response.data;
  },

  deleteRemise: async (id) => {
    const response = await api.delete(`/${id}`);
    return response.data;
  },
};
